import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { FamilyFestGetAllPickupLocationsAsync, FamilyFestCreatePickupLocationAsync, FamilyFestUpdatePickupLocationAsync, FamilyFestDeletePickupLocationAsync, FamilyFestClosePickupLocationAsync, FamilyFestGetPickupLocationsPaginatedAsync, FamilyFestGetTransportDashboardSummaryAsync, FamilyFestGetTransportDashboardTrendAsync, FamilyFestGetPickupLocationsNotPaginatedAsync, getFamilyFestPickupLocationByIdAsync } from './familyFestPickupLocationThunk';
const initialState = {
    status: APIStatus.IDLE,
    familyFestPickupLocations: [],
    familyFestPickupLocationsList: [],
    familyFestPickupLocation: undefined,
    familyFestCloseResponse: undefined,
    pickupLocationsPaginated: null,
    transportDashboardSummary: undefined,
    transportDashboardTrend: undefined
};
export const familyFestPickupLocationSlice = createSlice({
    name: 'familyFestPickupLocation',
    initialState,
    reducers: {
        resetFamilyFestPickupLocationStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(FamilyFestGetAllPickupLocationsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestGetAllPickupLocationsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestPickupLocations = action.payload;
        })
            .addCase(FamilyFestGetAllPickupLocationsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestGetPickupLocationsPaginatedAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestGetPickupLocationsPaginatedAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocationsPaginated = action.payload;
        })
            .addCase(FamilyFestGetPickupLocationsPaginatedAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestGetTransportDashboardSummaryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(FamilyFestGetTransportDashboardSummaryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.transportDashboardSummary = action.payload;
        })
            .addCase(FamilyFestGetTransportDashboardSummaryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestGetTransportDashboardTrendAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(FamilyFestGetTransportDashboardTrendAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.transportDashboardTrend = action.payload;
        })
            .addCase(FamilyFestGetTransportDashboardTrendAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestCreatePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestCreatePickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestPickupLocation = action.payload;
        })
            .addCase(FamilyFestCreatePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestUpdatePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestUpdatePickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestPickupLocation = action.payload;
        })
            .addCase(FamilyFestUpdatePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestDeletePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestDeletePickupLocationAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(FamilyFestDeletePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestClosePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestClosePickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestCloseResponse = action.payload;
            if (action.payload.isSuccess && action.payload.data) {
                state.familyFestPickupLocation = action.payload.data;
            }
        })
            .addCase(FamilyFestClosePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestPickupLocationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(getFamilyFestPickupLocationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestPickupLocation = action.payload;
        })
            .addCase(getFamilyFestPickupLocationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestGetPickupLocationsNotPaginatedAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
        })
            .addCase(FamilyFestGetPickupLocationsNotPaginatedAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestPickupLocationsList = action.payload;
        })
            .addCase(FamilyFestGetPickupLocationsNotPaginatedAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetFamilyFestPickupLocationStatus } = familyFestPickupLocationSlice.actions;
export default familyFestPickupLocationSlice.reducer;
